<template>
  <div class="employee-certification">
    <el-form label-width="140px">
      <el-row gutter="24">
        <el-col :span="11">
          <el-form-item label="姓名：">
            <el-input v-model="promotionData.employee_name" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="工号：">
            <el-input v-model="promotionData.employee_no" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row gutter="24">
        <el-col :span="11">
          <el-form-item label="部门：">
            <el-input v-model="promotionData.department_ids" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="职级类型：">
            <el-input v-model="promotionData.level_type" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row gutter="24">
        <el-col :span="11">
          <el-form-item label="当前职级：">
            <el-input v-model="promotionData.current_level" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="当前称号：">
            <el-input v-model="promotionData.current_title" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row gutter="24">
        <el-col :span="11">
          <el-form-item label="下一职级：">
            <el-input v-model="promotionData.next_level" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="下级称号：">
            <el-input v-model="promotionData.next_title" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row gutter="24">
        <el-col :span="11">
          <el-form-item label="开始从业日期：" >
            <el-input v-model="promotionData.start_work_date" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="从业年限：" >
            <el-input v-model="promotionData.work_years" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row gutter="24">
        <el-col :span="11">
          <el-form-item label="最低从业年限：" class="bold-label" label-position="left">
            <el-input v-model="promotionData.min_year" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :offset="9" :span="4">
          <el-checkbox v-model="promotionData.is_reach_year" disabled>达成</el-checkbox>
        </el-col>
      </el-row>
    </el-form>

    <el-row gutter="20">
      <el-col :span="10">
        <el-form-item label="晋升前置条件：" class="bold-label" label-width="180px" label-position="left">

        </el-form-item>
      </el-col>
    </el-row>
    <el-row gutter="20">
      <el-col :offset="2" :span="22">
        <el-table :data="promotionBeforeTable" style="width: 90%" :header-cell-style="headStyle">
          <el-table-column type="index" label="序号" width="100" align="right"></el-table-column>
          <el-table-column label="晋升前置条件" align="center">
            <template #default="scope">
              完成{{ scope.row.short_name }}认证
            </template>
          </el-table-column>
          <el-table-column label="达成" width="100" align="center">
            <template #default="scope">
              <el-checkbox v-model="scope.row.is_certified" disabled></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-row gutter="20">
      <el-col :span="10">
        <el-form-item label="考核前置条件：" class="bold-label" label-width="180px"
                      label-position="left">
        </el-form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :offset="2" :span="22">
        <el-table :data="examConditionTable" style="width: 90%" :header-cell-style="headStyle">
          <el-table-column type="index" label="序号" width="100" align="right"></el-table-column>
          <el-table-column prop="condition" label="考核前置条件" align="center">
            <template #default="scope">
              {{ scope.row.exam_content }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="达成" width="100" align="center">
            <template #default="scope">
              <el-checkbox v-model="scope.row.is_passed" disabled></el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <h4 style="margin-left: 5px">晋升考核：</h4>
    <el-form>
      <el-row gutter="24">
        <el-row :span="6">
          <el-form-item label="考核形式：" label-width="150px">
          </el-form-item>
          <el-checkbox-group v-model="promotionData.exam_function" disabled>
            <el-checkbox label="笔试" value="written"></el-checkbox>
            <el-checkbox label="面试" value="interview"></el-checkbox>
            <el-checkbox label="提问" value="question"></el-checkbox>
          </el-checkbox-group>
        </el-row>
        <el-col :span="22">
          <el-form-item label="考官要求：" label-width="140px">
            <el-input v-model="promotionData.exam_requirement" disabled/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <h4 style="margin-left: 5px">考核内容要求：</h4>
    <el-col  :offset="3">
      <el-table :data="examTable" :header-cell-style="headStyle" style="width: 90%">
        <el-table-column  type="index" label="序号" width="80" align="center">
        </el-table-column>
        <el-table-column prop="exam_content" label="考核内容" width="auto" align="center">
        </el-table-column>
        <el-table-column  width="100" align="center">
          <template #default="scope">
            <el-checkbox v-model="scope.row.is_passed" label="通过"></el-checkbox>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    <h4 style="margin-left: 5px">职级评定：</h4>
    <el-form label-width="140px">
      <el-row gutter="24">
        <el-col :span="11">
          <el-form-item label="下一职级：">
            <el-input v-model="promotionData.next_level" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="下级称号：">
            <el-input v-model="promotionData.next_title" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="22">
          <el-form-item label="备注：">
            <el-input type="textarea" :rows="5" v-model="promotionData.remark" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24" class="save-button">
        <el-button type="primary" @click="savePromotion">晋升</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "EmployeeLevelPromotion",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      promotionData: {},
      examConditionTable:[],
      examTable: [],
      promotionBeforeTable:[],
      exam_function:[],
      exam_requirement:"",
      //用来晋升时传递给后端无特殊用途
      examIds:[]
    }
  },
  methods: {
    headStyle() {
      return {
        'background-color': '#f0f0f0',
      }
    },

    async getData() {
      this.promotionData.employee_name = this.parentData.employee_name
      this.promotionData.employee_no = this.parentData.employee_no
      this.promotionData.department_ids = this.parentData.department_ids
      this.promotionData.level_type = this.parentData.level_type
      this.promotionData.current_level = this.parentData.current_level
      this.promotionData.current_title = this.parentData.current_title
      this.promotionData.next_level = this.parentData.next_level
      this.promotionData.next_title = this.parentData.next_title
      this.promotionData.start_work_date = this.parentData.start_work_date
      this.promotionData.min_year = this.parentData.min_year
      let params = {
        employee_no: this.parentData.employee_no
      }
      await this.$http("employeeLevelService.getExamContentByLevel", params).then(res =>{
        this.examConditionTable = res.exam_condition_data
        this.promotionBeforeTable = res.certified_records
        this.examTable = res.exam_table
        this.promotionData.exam_requirement = res.exam_requirement
        this.promotionData.exam_function = res.exam_function
        this.examIds = res.examIds
        this.promotionData.work_years = res.work_years
        this.promotionData.is_reach_year = res.is_reach_year
        console.log(this.promotionData)
      })
    },
    savePromotion() {
      let params = {
        promotionData: this.promotionData,
        examTable: this.examTable,
        examConditionTable : this.examConditionTable,
        promotionBeforeTable: this.promotionBeforeTable,
        examIds: this.examIds
    }
      console.log("params",params)
      this.$http("employeeLevelService.saveEmpLevelPromotionData", params).then(() => {
        this.$message.success("保存成功！");
        this.$fn.closeWindow();
        this.$fn.search();
      })
    },
  },
  created() {
    this.getData()
  }

}
</script>

<style scoped lang="less">
:deep .bold-label .el-form-item__label {
  font-weight: bold;
  color: black;
}

.employee-certification {
  padding: 20px;
}

.certification-section {
  margin-top: 24px;
}

.save-button {
  text-align: center;
  margin-top: 24px;
}
</style>